// AdminLogin.jsx – Login mit Passwort + OTP-2FA
import React, { useState } from 'react';
import './Admin.css';

export default function AdminLogin({ api, onLogin }) {
  const [step, setStep] = useState('credentials'); // 'credentials' | 'otp'
  const [email] = useState('stammbaum-memo@bandeleart.ch');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCredentials = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${api}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const d = await res.json();
      if (!res.ok) { setError(d.error || 'Ungültige Anmeldedaten'); setLoading(false); return; }
      setStep('otp');
    } catch {
      setError('Server nicht erreichbar');
    } finally {
      setLoading(false);
    }
  };

  const handleOtp = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${api}/api/admin/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp }),
      });
      const d = await res.json();
      if (!res.ok) { setError(d.error || 'Ungültiger oder abgelaufener Code'); setLoading(false); return; }
      onLogin(d.token);
    } catch {
      setError('Server nicht erreichbar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-bg">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#1540dc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
          </svg>
        </div>
        <h1 className="admin-login-title">Stammbaum-Memo Admin</h1>

        {step === 'credentials' ? (
          <form onSubmit={handleCredentials}>
            <div className="admin-field">
              <label>E-Mail</label>
              <input type="email" value={email} readOnly
                style={{ background: '#F9F9F9', color: '#888', cursor: 'default' }} />
            </div>
            <div className="admin-field">
              <label>Passwort</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Admin-Passwort"
                required
                autoFocus
              />
            </div>
            {error && <p className="admin-error">{error}</p>}
            <button type="submit" className="admin-btn admin-btn--primary" disabled={loading || !password}>
              {loading ? 'Wird geprüft…' : 'Weiter'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleOtp}>
            <p className="admin-otp-hint">
              Ein 6-stelliger Einmalcode wurde an <strong>{email}</strong> gesendet.
              Bitte prüfe dein Postfach.
            </p>
            <div className="admin-field">
              <label>Einmalcode</label>
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                value={otp}
                onChange={e => setOtp(e.target.value.replace(/\D/g, ''))}
                placeholder="000000"
                className="admin-otp-input"
                required
                autoFocus
              />
            </div>
            {error && <p className="admin-error">{error}</p>}
            <button type="submit" className="admin-btn admin-btn--primary" disabled={loading || otp.length < 6}>
              {loading ? 'Prüfen…' : 'Anmelden'}
            </button>
            <button
              type="button"
              className="admin-btn admin-btn--ghost"
              onClick={() => { setStep('credentials'); setOtp(''); setError(''); }}
            >
              Zurück
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
